module.exports = function getResource(label, vars = []) {
    const resources = {
        home: 'Accueil',
        groups: 'Groupes',
        conversations: 'Conversations',
        gallery: 'Galerie',
        communityNavigation: 'Navigation dans la collectivité',
        notificationsFeed: 'Flux de notifications',
        clickToJoin: 'Cliquez pour vous joindre à un groupe, commencer une conversation ou ajouter une photo ou une vidéo.',
        joinAGroup: 'Rejoindre un groupe',
        startAConversation: 'Commencer une conversation',
        addPhotoVideo: 'Ajouter une photo/vidéo'
    };
    return resources[label];
};
